import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/modals-dux';

import TagCell from './TagCell';
import TagDetail from './TagDetail';
import DeleteTagModal from './DeleteTagModal';
import { Row, Col, Button } from 'react-bootstrap';

const formatTags = tags => {
  if (!tags || !tags.length) return [];
  const tagGroups = _.groupBy((tags || []), 'color');

  return _.chain(Object.keys(tagGroups))
    .orderBy(color => color.toLowerCase())
    .map(key => _.orderBy(tagGroups[key], tag => tag.value.toLowerCase()))
    .value()

}

class TagsList extends Component {
  constructor(props) {
    super(props);
    this.onTagClick = this.onTagClick.bind(this);
    this.setIsEditing = this.setIsEditing.bind(this);
    this.setIsAdding = this.setIsAdding.bind(this);
    this.handleDeleteTag = this.handleDeleteTag.bind(this);
    this.state = { adding: false, editing: false };
  }
  componentDidMount() {
    this.props.getAllTags();
  }
  onTagClick(tag) {
    const { clearGetTagById, getTagById } = this.props;

    const{ _id } = tag || {};
    if (!_id) return;
    clearGetTagById();
    getTagById(_id);
  }
  setIsEditing(editing) {
    this.setState({ editing })
  }
  setIsAdding(adding) {
    this.setState({ adding })
  }
  handleDeleteTag(tag) {
    const { deleteTagById, clearDeleteTagById, clearGetTagById, getAllTags, closeModal } = this.props;
    deleteTagById(tag._id, null, null, () => {
      clearDeleteTagById();
      clearGetTagById();
      closeModal();
      getAllTags();
    });
  }
  render() {
    const { tags, activeTag, showModal, deleteTagById, deleteTagByIdInProgress } = this.props;
    const { editing, adding } = this.state;
    const tagGroups = formatTags(tags);
    const onDeleteTag = () => {
      showModal('DeleteTagModal');
    }
    return (
      <div>
        <DeleteTagModal
          tagToDelete={activeTag}
          handleDeleteTag={this.handleDeleteTag}
          deleteTagByIdInProgress={deleteTagByIdInProgress}
        />
        <div className="header">
          <div className="container-fluid">
            <Button className="actions" bsStyle="success" onClick={() => this.setIsAdding(true)}>
              <span className="ti ti-plus" /> Add Tag
            </Button>
            <h1>Tags</h1>
          </div>
        </div>
        <div className="container">
          <Row>
            <Col sm={6}>
              {(tagGroups || []).map(group => (
                <div>
                  {(group || []).map(tag =>
                    <div className="tag-item">
                      <TagCell tag={tag} handleClick={this.onTagClick} />
                    </div>
                  )}
                </div>
              ))}
            </Col>
            <Col sm={6}>
              <TagDetail
                tag={activeTag}
                setIsEditing={this.setIsEditing}
                setIsAdding={this.setIsAdding}
                editing={editing}
                adding={adding}
                onDeleteTag={onDeleteTag}
              />
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

const mapState = state => {
  const {
    result: tags,
    error: tagsErr
  } = state.getAllTags.toJS();
  const {
    result: activeTag,
    error: getTagByIdErr
  } = state.getTagById.toJS();
  const {
    inProgress: deleteTagByIdInProgress,
    error: deleteTagByIdError
  } = state.deleteTagById.toJS();

  const error = tagsErr || getTagByIdErr;

  return {
    activeTag,
    error,
    tags,
    deleteTagByIdInProgress,
    deleteTagByIdError
  };
};
const mapDispatch = dispatch => bindActionCreators({
  ...actionCreators,
  getAllTags: fetchDux.getAllTags.createAction,
  clearGetAllTags: fetchDux.getAllTags.clearAction,
  getTagById: fetchDux.getTagById.createAction,
  clearGetTagById: fetchDux.getTagById.clearAction,
  deleteTagById: fetchDux.deleteTagById.createAction,
  clearDeleteTagById: fetchDux.deleteTagById.clearAction,
}, dispatch);

export default connect(mapState, mapDispatch)(TagsList);



// WEBPACK FOOTER //
// ./src/components/routes/tags/TagsList.js